import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, pos) {
        return {x: 0, y: 0}
    },
    routes: [
        {path: '/',                     name: 'index',          component: () => import('@/views/index')},

        {path: '/cyber/ethics',         name: 'ethics',         component: () => import('@/views/cyber/ethics')},
        {path: '/cyber/gab',            name: 'gab',            component: () => import('@/views/cyber/gab')},
        {path: '/cyber/office',         name: 'office',         component: () => import('@/views/cyber/office')},
        {path: '/cyber/unfair',         name: 'unfair',         component: () => import('@/views/cyber/unfair')},
        {path: '/cyber/praise',         name: 'praise',         component: () => import('@/views/cyber/praise')},
        {path: '/cyber/worker',         name: 'worker',         component: () => import('@/views/cyber/worker')},
        {path: '/cyber/write/:flag',    name: 'write',          component: () => import('@/views/cyber/write')},

        {path: '/result/login',         name: 'resultLogin',    component: () => import('@/views/result/login')},
        {path: '/result/list',          name: 'resultList',     component: () => import('@/views/result/list')},
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js